import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { Button, Modal } from "carbon-components-react";
import { TrashCan16 } from "@carbon/icons-react";

import APIClient from "web_modules/APIClient";

import { PIPELINE_PAGE_URL } from "web_modules/reporting_dashboard/PipelinePage";
import { ViewsContext, View } from "web_modules/reporting_dashboard/PipelinePage/viewsContext";

const softDeleteView = (id: string): Promise<View> => {
  return APIClient.deleteRequest(`/ro/pipeline_views/${id}`).then(({ pipeline_view }) => {
    return pipeline_view;
  });
};

type Props = {
  viewId: string;
  history: any;
};

const DeleteViewModal: React.FunctionComponent<Props> = ({ viewId, history }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const reset = () => {
    setModalIsOpen(false);
  };

  return (
    <ViewsContext.Consumer>
      {({ deleteView }) => (
        <>
          <Modal
            open={modalIsOpen}
            danger
            modalHeading="Delete view"
            primaryButtonText="Delete"
            secondaryButtonText="Cancel"
            aria-label="delete view"
            onBlur={reset}
            onRequestClose={reset}
            onRequestSubmit={async () => {
              const newView = await softDeleteView(viewId);

              deleteView(newView);

              setModalIsOpen(false);
              history.replace(PIPELINE_PAGE_URL);
            }}
          >
            <h3>Warning: you are deleting this view for everyone</h3>
          </Modal>

          <Button
            kind="ghost"
            onClick={() => setModalIsOpen(true)}
            renderIcon={TrashCan16}
            iconDescription="Delete view"
          >
            Delete view
          </Button>
        </>
      )}
    </ViewsContext.Consumer>
  );
};

const mapStateToProps = (state, ownProps) => ({
  viewId: ownProps.match.params.viewId,
});

const connectedDeleteViewModal = connect(mapStateToProps)(DeleteViewModal);

export default withRouter(connectedDeleteViewModal);
